import { render, staticRenderFns } from "./Factures.vue?vue&type=template&id=65e540e0&scoped=true&"
import script from "./Factures.vue?vue&type=script&lang=js&"
export * from "./Factures.vue?vue&type=script&lang=js&"
import style0 from "./Factures.vue?vue&type=style&index=0&id=65e540e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e540e0",
  null
  
)

export default component.exports